import { emptySelectOptionZod } from 'components/Select'
import { CommonSchema } from 'features/globalSetup/forms/Prebid/Bidders/schemas/commonSchema'
import { DEFAULT_CONSENT_MODE, DEFAULT_CPM_ADJUSTMENT } from '../constants'
import { BidderSlice } from '../types'

export type AddOwnSchema = Extract<AddSchema, { accountType: 'own' }>
export type AddSchema = CommonSchema
export type AddThirdPartyProviderSchema = Extract<AddSchema, { accountType: 'thirdPartyProvider' }>
export type AddYieldbirdSchema = Omit<Extract<AddSchema, { accountType: 'yieldbird' }>, 'status'>

export const addSchemaDefault: AddSchema = {
  accountType: 'own',
  bidCpmAdjustment: DEFAULT_CPM_ADJUSTMENT,
  bidderCode: '',
  bidderId: emptySelectOptionZod<BidderSlice>(),
  bidderSid: '',
  consentMode: DEFAULT_CONSENT_MODE,
  priority: 'primary',
}
